import { Text } from '@pm/ui';
import { useTranslation } from 'react-i18next';
import { EncounterDetail } from './EncounterDetail';

type AppointmentDurationProps = {
  durationInMinutes: number;
};

export const AppointmentDuration = ({
  durationInMinutes,
}: AppointmentDurationProps) => {
  const { t } = useTranslation('appointments', {
    keyPrefix: 'Appointment.Summary',
  });

  const appointmentDuration = t('AppointmentDuration', {
    durationInMinutes,
  });

  return (
    <EncounterDetail iconName="schedule">
      <Text size="bodyL" title={appointmentDuration}>
        {appointmentDuration}
      </Text>
    </EncounterDetail>
  );
};
